// extracted by mini-css-extract-plugin
export var numpadContainer = "_s6-1";
export var phoneButton = "_s6-0";